import { pathsEntries } from '../domains';
import { createTranslatedPathnames, mergeTranslatedPathnames, type RoutePathsEntry } from './getTranslatedPathnames';
import * as routerPathsModule from './routePaths';

// The vite.config.ts mirror walks `src/domains/*/route.paths.ts` in folder
// order and feeds the same `mergeTranslatedPathnames` — paraglide's URL pattern
// matcher is first-match-wins, so iteration order must match across runtime
// and config time. The router's own paths (RouterPaths) are appended last as
// an explicit entry since they live outside `domains/`.
const entries: RoutePathsEntry[] = [
  ...pathsEntries.map(([name, mod]) => [`./${name}/route.paths.ts`, mod] as const),
  ['./router/routePaths.ts', routerPathsModule] as const,
];

// Hardcoded base locale to keep this module's runtime deps minimal — paraglide
// runtime is generated and not always available when the router domain is loaded
// for tooling (e.g., Nx project graph).
const baseLocale = 'de';

export const translatedPathnames = createTranslatedPathnames(mergeTranslatedPathnames(entries), baseLocale);
